<script setup lang="ts">
/**
 * NewsSignupPrompt — 입시 소식 상세의 가입·로그인 유도(083 FR-012). **비로그인일 때만** 보인다.
 * 분석 기능 진입 유도("내 성적으로 확인하기" 등)는 1차 범위에서 넣지 않는다(#358 해결 후).
 *
 * 프리렌더 HTML 에는 그리지 않는다 — 빌드 시점엔 세션을 알 수 없어, 로그인 회원 화면에서 수화 후 블록이 사라지는
 * 불일치·깜빡임이 생긴다. 마운트 후 세션 복원이 끝난 다음 비로그인으로 확정됐을 때만 렌더한다.
 */
import { computed, onMounted, ref } from 'vue';
import { RouterLink } from 'vue-router';

import { buttonVariants } from '#/components/ui';
import { trackNewsSignupCta } from '#/lib/analytics';
import { useAuthStore } from '#/stores/auth';

const props = defineProps<{
  newsId: number;
}>();

const auth = useAuthStore();
const mounted = ref(false);
onMounted(() => {
  mounted.value = true;
});

const visible = computed(() => mounted.value && auth.sessionRestored && !auth.isAuthenticated);
/** 로그인 후 이 글로 돌아온다(LoginPage 의 redirect 쿼리 규약). */
const loginTo = computed(() => ({ path: '/login', query: { redirect: `/news/${props.newsId}/` } }));
</script>

<template>
  <section
    v-if="visible"
    class="bg-accent-soft/50 mt-8 rounded-card border border-accent-line p-5 text-center md:p-6"
  >
    <p class="text-[15px] font-extrabold text-brand">새 입시 소식을 놓치지 마세요</p>
    <p class="mt-1.5 text-[13px] text-body">
      회원가입하면 입시 자료 구매와 내 자료실을 함께 이용할 수 있어요.
    </p>
    <div class="mt-4 flex flex-wrap justify-center gap-2">
      <RouterLink
        to="/signup"
        :class="buttonVariants({ variant: 'accent', size: 'md' })"
        @click="trackNewsSignupCta(newsId, 'signup')"
      >
        회원가입
      </RouterLink>
      <RouterLink
        :to="loginTo"
        :class="buttonVariants({ variant: 'line', size: 'md' })"
        @click="trackNewsSignupCta(newsId, 'login')"
      >
        로그인
      </RouterLink>
    </div>
  </section>
</template>
